import { Instance } from 'mobx-state-tree'
import { LessonModelBase } from './LessonModel.base'

/* The TypeScript type of an instance of LessonModel */
export interface LessonModelType extends Instance<typeof LessonModel.Type> {}

/* A graphql query fragment builders for LessonModel */
export { selectFromLesson, lessonModelPrimitives, LessonModelSelector } from './LessonModel.base'

/**
 * LessonModel
 */
export const LessonModel = LessonModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
